import { CodeBlock } from '../../../../shared-components';
import { devSettings } from '../../../../../@xmcloud/core/messages/en';
import { EnvironmentClass } from '../../../../../@xmcloud/utils/constants';
import { IGetEnvironmentResponse } from '../../../../models/environmentModel';
import { environment } from '../../../../config/envConfig';
import {
	buildEdgeUrlLine,
	buildOptionalSecretLine,
	pickContextId,
} from './developerSettingsEnvVars';

const { editingSecretNotFound } = devSettings;
const { prod: PRODUCTION } = EnvironmentClass;

export const NewJssVersionSettings: React.FC<{
	environmentDetail: IGetEnvironmentResponse;
	isPreview: boolean;
	editingSecret: string;
	siteName: string;
	isEditingSecretAvailable: boolean;
}> = ({
	environmentDetail,
	isPreview,
	editingSecret,
	siteName,
	isEditingSecretAvailable,
}) => {
	const previewContextId = environmentDetail?.previewContextId || '';
	const liveContextId = environmentDetail?.liveContextId || '';
	const isProduction = environment === PRODUCTION;
	const contextId = pickContextId(isPreview, previewContextId, liveContextId);

	const envVariablesLines = [
		...buildEdgeUrlLine(isProduction),
		`SITECORE_EDGE_CONTEXT_ID=${contextId}`,
		`SITECORE_SITE_NAME=${siteName}`,
		...buildOptionalSecretLine({
			isPreview,
			isAvailable: isEditingSecretAvailable,
			variableName: 'JSS_EDITING_SECRET',
			value: editingSecret,
			notFoundText: editingSecretNotFound,
		}),
	];

	return (
		<CodeBlock
			items={envVariablesLines}
			clipboardText={envVariablesLines.join('\n')}
			data-testid="code-block"
			key="environment-code-block"
		/>
	);
};
